import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { basketGet } from "./api";
export default function BasketNavLink() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    let live = true;
    basketGet("capabilities")
      .then((r) => {
        if (live)
          setVisible(
            r.producer ||
              r.capabilities.includes("view") ||
              r.scoped_capabilities?.includes("view"),
          );
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, []);
  return visible ? (
    <li className="nav-item">
      <Link className="nav-link" to="/reusable-baskets">
        <span className="menu-title">Reusable baskets</span>
      </Link>
    </li>
  ) : null;
}
